import { CtaIcon } from 'components/Common/Icon'
import Link from 'next/link'
import styles from './CtaSection.module.css'

const CtaSection = () => {
  return (
    <section className={styles.ctaSection}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12">
            <div className={styles.content}>
              <h2 className={styles.title}>
                Get AI-Powered Marketing Working for Your Business Today
              </h2>
              <p className={styles.subtitle}>
                Unlock smarter campaigns, higher conversions, and measurable
                growth with AI-driven strategies.
              </p>
              <Link
                className="cta-button cta-button-black cta-button-main"
                href="/get-quote/"
              >
                <span>Schedule Your Free Consultation</span>
                <span className="arrow">
                  <CtaIcon className="fill-white" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CtaSection
